import { createContext, ReactNode, useState } from 'react';

type ChatLayoutContextType = {
  isChatDrawerOpen: boolean;
  setIsChatDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultChatLayoutContext = {
  isChatDrawerOpen: false,
  setIsChatDrawerOpen: () => {},
};

export const ChatLayoutContext = createContext<ChatLayoutContextType>(
  defaultChatLayoutContext,
);

export const ChatLayoutProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const [isChatDrawerOpen, setIsChatDrawerOpen] = useState<boolean>(false);
  return (
    <ChatLayoutContext.Provider
      value={{ isChatDrawerOpen, setIsChatDrawerOpen }}
    >
      {children}
    </ChatLayoutContext.Provider>
  );
};
